import { useLoadScript } from '@react-google-maps/api';

export function useMapInstance() {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || ''
  });

  return { isLoaded };
}
